import { Component, OnInit, ViewChild } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../../../shared';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { RetentionService } from '../../services/retention.service';
import { ProviderService } from '../../services/provider.service';
import { PDFService } from '../../services/pdf.service';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-retention-list',
  templateUrl: 'retention-list.component.html',
  styleUrls: ['retention-list.component.scss'],
  providers: [RetentionService, ProviderService, PDFService]
})
export class RetentionListComponent implements OnInit {
  tableSettingsRetention: any = undefined;
  dataSourceRetention: any = undefined;

  @ViewChild('myTable') myTable: any;


  select_wo: boolean = false;
  budgetData: any;
  tax_text = 'IGV';
  total: any = 0;
  totalFinal: any = 0;
  datosproveedor;
  RetentionDetailData: any = [];
  priceWithTax: any = 0;
  RetentionHeaderlData: any = [];
  RetentionHeaderPrice: any;
  Retentiondetalle: any = [];
  preciototal;
  filtroproveedor;
  filtronombreprovider;
  filteredOptions1 = '';
  fechainicio;
  fechafinal;
  stringmontototal;
  razonSocial='';
  nombreprovedor='';

  tableDataRetention: any = {};
  listProviders: any = [];
  perPage = 10;
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'editar', title: `<div class="editCustomButton">Editar</div>` },
      
     /*   { name: 'eliminar', title: `<div class="editCustomButton">Eliminar</div>` }*/
      ]
    }
  };
  constructor(
    private route: Router,
    private RetentionService: RetentionService,
    public dialog: MatDialog,
    private pdfService: PDFService,
    private providerService: ProviderService,
    private notifierService: NotifierService
  ) {
    this.providerService.listProviders().subscribe((result: any) => {
      this.listProviders = result;
    });
    this.tableDataRetention = {
      columns: {
        doc_comprobante: { title: 'Comprobante' },
        provider_name: { title: 'Proveedor'},
        legal_name: { title: 'Razón Social'},
        fecha_emision: { title: 'Fecha Emisión' },
        
        currency: { title: 'Moneda' },
        importe_retenido: { title: 'Total Retenido' },
        user_name: { title: 'Creado Por' },
        observaciones: { title: 'Observación' },
        estado: { title: 'Estado' },
        
      },
      data: {}
    };
  }
  ngOnInit() {
    this.tableSettingsRetention = this.copyObject(this.settings);
    this.providerService.listProviders().subscribe((result) => {
      this.listProviders = result;
      this.RetentionService.getAllRetentionHeaders().subscribe((result: any) => {
        this.getTableData(result);
      });
    });

  }


  getProveedor(event?) {
    if (event) {
        this.filteredOptions1 = event.target.value
    }
    this.providerService.getProviderByName(this.filteredOptions1.replace(/ /g, ""))
        .subscribe(
            result => {
                this.listProviders = result as Array<any>
                this.filtroproveedor = this.listProviders[0].id;

            },
            error => {
                console.log('error', error)
            }
        )
}

  onProviderSelected(selectedUsuario) {
    this.filtroproveedor = selectedUsuario.id;
  }

  enableBtnDownloadList = true;

  downloadTable() {
    // Si se cambia la propiedad relacionada a las columnas, los filtros van a cambiar
    this.enableBtnDownloadList = false;

    if (this.fechainicio && this.fechafinal) {


     
      if (moment(this.fechainicio).format('YYYY-MM-DD') <= moment(this.fechafinal).format('YYYY-MM-DD')) {
        this.fechainicio = moment(this.fechainicio).format('YYYY-MM-DD');
        this.fechafinal = moment(this.fechafinal).format('YYYY-MM-DD');



      if (this.dataSourceRetention) {
        const { filters } = (this.dataSourceRetention as LocalDataSource).getFilter();

        console.log(filters, ' fs')

        if (filters && filters.length >= 0) {

          const doc_comprobante = filters.find( (f: any) => f.field === 'doc_comprobante' && f.search !== '' );
          const provider = filters.find( (f: any) => f.field === 'provider_name' && f.search !== '' );
          const legalName = filters.find( (f: any) => f.field === 'legal_name' && f.search !== '');
          const fecha_emision = filters.find( (f: any) => f.field === 'fecha_emision' && f.search !== '');
          const observaciones = filters.find( (f: any) => f.field === 'observaciones' && f.search !== '');
          const createdBy  = filters.find( (f: any) => f.field === 'user_name' && f.search !== '');
          const currency = filters.find( (f: any) => f.field === 'currency' && f.search !== '' );
          const estado = filters.find( (f: any) => f.field === 'estado' && f.search !== '' );
          
          
          const objFilters = {
            code: doc_comprobante ? doc_comprobante.search : null, 
            provider: provider ? provider.search : null, 
            legalName: legalName ? legalName.search : null, 
            fecha_emision: fecha_emision ? fecha_emision.search : null, 
            observaciones: observaciones ? observaciones.search : null, 
            createdBy: createdBy ? createdBy.search : null,
            currency: currency ? currency.search : null,
            estado: estado ? estado.search : null,
            fechaInicio:   this.fechainicio,
            fechaFin: this.fechafinal
          }

          console.log(objFilters, 'objf')

          this.notifierService.systemNotify({
            title: 'Procesando información',
            message: 'Exportando lista de Comprobantes...',
            type: 'info',
          });

          this.RetentionService.downloadRetentionList(objFilters)
          .subscribe( (result ) => {
            let blob = result as any;
            let fileName = `lista_ordenes_compra`;
            fileSaver.saveAs(blob, fileName);
            this.notifierService.systemNotify({
              title: 'Descarga completada',
              message: 'Lista de comprobantes descargada correctamente',
              type: 'success',
            });
            this.enableBtnDownloadList = true;
          }, (error) => {
            this.notifierService.systemNotify({
              title: 'Error',
              message: 'No se ha podido descargar la lista de comprobantes',
              type: 'error'
            });
            this.enableBtnDownloadList = true;
          })
        } else {
          this.enableBtnDownloadList = true;
        }

      }else {
        this.enableBtnDownloadList = true;
      }

    }else{
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'La fecha de inicio debe ser menor a la fecha de fin',
        type: 'error',
        duration: 5000
      });
    }
  }else{
    this.notifierService.systemNotify({
      title: 'Error',
      message: 'Debe ingresar fechas de filtro',
      type: 'error',
      duration: 5000
    });
  }

  }




     getTableData(result) {
    const cloneRows: Array<any> = [...result];

    for (const item of cloneRows) {
      item.created_date = moment(item.created_date).format('DD/MM/YYYY');
      item.fecha_emision = moment(item.fecha_emision).format('DD/MM/YYYY');

      const found = this.listProviders.find((element) => {
        // tslint:disable-next-line:triple-equals
        return element.id == item.id_provider;
      });
      item.provider_name = found.comercial_name
      item.legal_name = found.social_reason

    }

    this.dataSourceRetention = new LocalDataSource(cloneRows);

    this.tableSettingsRetention = this.copyObject(this.settings);
    if (this.tableDataRetention.columns !== undefined) {
      this.tableSettingsRetention.columns = this.copyObject(this.tableDataRetention.columns);
      // Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.tableSettingsRetention.columns).forEach(key => {
        this.tableSettingsRetention.columns[key].filter = true;
      });
    }

    this.tableSettingsRetention.columns.importe_retenido.valuePrepareFunction =
    this.prepareProfilePicCell;
  this.tableSettingsRetention.columns.importe_retenido.type = "html";


    if (localStorage.getItem('filter-retention') != '' && localStorage.getItem('filter-retention') ){

      var elem = JSON.parse(localStorage.getItem('filter-retention') );
      if (cloneRows.length > 0){
        this.dataSourceRetention.setFilter(elem.filters);
        localStorage.setItem('filter-retention', '');
      }
      
    }




  }

  customRetentionAction(event) {
    switch (event.action) {
      case 'editar':
          localStorage.setItem('filter-retention' ,JSON.stringify(this.dataSourceRetention.getFilter()));

        this.route.navigate(['/system/retention/edit', event.data.id]);
        break;
     /* case 'eliminar':
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: 'exclamation-circle',
            iconColor: 'failure',
            title: 'Aviso',
            text: `¿Está seguro que desea eliminar el comprobante?`,
            options: true
          }
        });
        deleteDialog.afterClosed().subscribe((result) => {
          if (result) {
            this.RetentionService.deleteRetentionHeader(event.data.id).subscribe((deleteResult) => {
              this.notifierService.systemNotify({
                title: 'Éxito',
                message: 'Se ha eliminado el Cliente con exito',
                type: 'success'
              });
              this.ngOnInit();
            });
          }
        }, (error) => {
          console.log('error', error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'No se ha podido eliminar la Orden de Compra',
            type: 'error'
          });
          this.ngOnInit();
        });

        break;*/
    }
  }
  prepareProfilePicCell(cell, row): string {
    if (cell) {
      return `<div class='text-rigth'>${cell}</div>`;
    } else {
      return "";
    }
  }

  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }
}



// WEBPACK FOOTER //
// ./src/app/system/retention/retention-list/retention-list.component.ts